/* projects/shared/nvps-libraries/design/nv-language-switcher/nv-language-switcher.component.scss */
nv-language-switcher .language-switcher {
  display: flex;
  align-items: center;
}
nv-language-switcher .language-switcher nv-pill-button-v4 button {
  color: #fff;
  background: transparent;
  font-family: var(--font-family-normal);
  font-weight: normal;
  padding: 0;
}
/*# sourceMappingURL=nv-language-switcher.component-AT2CIPAD.css.map */
